import React from "react";
import PropTypes from "prop-types";

import { FormattedNumber } from "react-intl";

function PercentageCell({ value, total, className = "" }) {
  if (value <= 0) {
    return <div className={`percentage-cell ${className}`}>-</div>;
  }
  if (value >= 0 && total > 0) {
    return (
      <div className={`percentage-cell ${className}`}>
        {value}&nbsp;(
        <FormattedNumber
          style="percent"
          value={value / total}
          minimumFractionDigits={0}
          maximumFractionDigits={2}
        />
        )
      </div>
    );
  }
  if (value >= 0) {
    return <div className={`percentage-cell ${className}`}>{value}</div>;
  }
  return <div className={`percentage-cell ${className}`}>-</div>;
}

PercentageCell.propTypes = {
  value: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default PercentageCell;
